import React from 'react'

import {
  useIsPlaybackStateReady,
  useIssetPlaybackMetricsReady,
  usePlaybackSettings,
} from '../../../../firebase/hooks/useVideoPlayback'
import { useOnDemandPlayback } from '../../hooks/use-on-demand-playback'

import './on-demand-playback.scss'

interface OnDemandPlaybackProps {
  isVisible: boolean
}

const OnDemandPlayback = ({ isVisible }: OnDemandPlaybackProps) => {
  const { videoElementRef } = useOnDemandPlayback()

  const playbackSettings = usePlaybackSettings()
  const isPlaybackStateReady = useIsPlaybackStateReady()
  const isPlaybackMetricsReady = useIssetPlaybackMetricsReady()

  if (!isPlaybackStateReady || !isPlaybackMetricsReady) return null

  const style = {
    opacity: isVisible ? '1' : '0.01',
  }

  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      style={style}
      ref={videoElementRef}
      loop={playbackSettings?.shouldLoop}
      className="on-demand-playback"
      crossOrigin="anonymous"
    />
  )
}

export { OnDemandPlayback }
